import { createSelector } from 'reselect';
import { Map as IMap } from 'immutable';
import { getBrandCode, getEgcRecommendedDenoms, getPlasticRecommendedDenoms } from '../brand/brandSelectors';
import { getIntl, getIntlLocale, messages } from '../intl/intlSelectors';
import { getActivePromoCode } from '../promo/promoSelectors';
import {
    getCurrencyCode,
    getGrandTotal,
    getTotalCardQuantity
} from '../productCartHandler/productCartSelectors';
import { getShippingDisplayName } from '../shipping/shippingSelectors';
import { CPF_NUMBER_FIELD } from '../constants/constants';


export const getCartState = state => state.get('cart', IMap());

export const getCartStatus = createSelector(
    getCartState,
    cart => cart.get('cartStatus', null)
);

export const getProductsSegmentData = createSelector(
    [
        getBrandCode,
        getCurrencyCode,
        getIntlLocale,
        getEgcRecommendedDenoms,
        getPlasticRecommendedDenoms,
        getActivePromoCode,
        getIntl,
        getGrandTotal,
        getTotalCardQuantity,
        (state, intl) => getShippingDisplayName(state, intl)
    ],
    (
        brandCode,
        currencyCode,
        locale,
        egcRecommendedDenoms,
        plasticRecommendedDenoms,
        promoCode,
        intl,
        grandTotal,
        cardQuantity,
        shippingDisplayTexts
    ) => ({
        brandCode,
        currencyCode,
        locale,
        egcRecommendedDenoms,
        plasticRecommendedDenoms,
        promoCode,
        intl,
        grandTotal,
        cardQuantity,
        shippingDisplayTexts
    })
);

export const getCartTextMessage = createSelector(
    messages,
    (msgs) => {
        const msg = msgs.get('cartPage.cartPageMessages.cartText', '');
        if (typeof msg === 'string' && msg.trim().length > 0) {
            return msg;
        }
        return null;
    }
);

export const getCPFNumber = createSelector(
    getCartState,
    cart => (cart ? cart.get(CPF_NUMBER_FIELD, '') : '')
);

/**
 * Get the value of whether the cart was edited or not.
 * @param {Immutable.Map} state - the redux store for session
 * @returns a boolean value
 */
export const getIsCartEdited = createSelector(
    getCartState,
    cart => cart.get('isCartEdited')
);

export const getIsOfferSectionLoading = createSelector(
    getCartState,
    cart => cart.get('isOfferSectionLoading', false)
);
